import { Facebook, MapPin, Mail, Phone, MessageCircle } from 'lucide-react'
import type { HotelProfile } from '../api/types'

export function Footer({ hotel }: { hotel?: HotelProfile }) {
  if (!hotel) return null
  const social = hotel.social_links || {}

  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div className="footer-col">
          {hotel.logo_image ? (
            <img src={hotel.logo_image} alt={hotel.hotel_name} className="footer-logo" />
          ) : (
            <h3 className="footer-brand">{hotel.hotel_name}</h3>
          )}
          <p>{hotel.short_description}</p>
        </div>
        <div className="footer-col">
          <h4>Contacto</h4>
          <ul>
            {hotel.phone && (
              <li><Phone size={16} /> <a href={`tel:${hotel.phone}`}>{hotel.phone}</a></li>
            )}
            {hotel.email && (
              <li><Mail size={16} /> <a href={`mailto:${hotel.email}`}>{hotel.email}</a></li>
            )}
            {hotel.address && (
              <li><MapPin size={16} /> {[hotel.address, hotel.city, hotel.country].filter(Boolean).join(', ')}</li>
            )}
          </ul>
        </div>
        <div className="footer-col">
          <h4>Síguenos</h4>
          <div className="social-links">
            {social.facebook && (
              <a href={social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={22} />
              </a>
            )}
            {social.whatsapp && (
              <a
                href={`https://wa.me/${social.whatsapp.replace(/[^0-9]/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <MessageCircle size={22} />
              </a>
            )}
          </div>
        </div>
      </div>
      {hotel.footer_text && <div className="footer-bottom">{hotel.footer_text}</div>}
    </footer>
  )
}
